<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  outlined
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocompleteOutlined",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    this.timer = null;
    this.requestId = 0;
    this.destroyed = false;
    this.geocoderPromise = GeocoderFactory().then(geocoder => {
      this.geocoder = geocoder;
      if (this.destroyed) {
        geocoder.destroy();
      }
      return geocoder;
    });
  },

  beforeDestroy() {
    this.destroyed = true;
    this.stopPending();
  },

  watch: {
    search(val) {
      if (!val) {
        this.stopPending();
        if (!this.select) {
          this.items = [];
        }
        return;
      }
      if (this.select && typeof this.select === "object" && val === this.select.text) {
        return;
      }
      val !== this.select && this.querySelections(val) // eslint-disable-line
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    stopPending() {
      if (this.timer != null) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.requestId++;
      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }
      this.loading = false;
    },

    querySelections(value) {
      this.stopPending();
      this.loading = true;
      const id = this.requestId;

      this.timer = setTimeout(() => {
        this.timer = null;
        this.geocoderPromise.then(geocoder => {
          if (id !== this.requestId || this.destroyed) {
            return null;
          }
          return geocoder.autocomplete(value);
        }).then(items => {
          if (id !== this.requestId || !Array.isArray(items)) {
            return;
          }
          this.items = items.slice();
        }).catch(() => {
          if (id === this.requestId) {
            this.items = [];
          }
        }).finally(() => {
          if (id === this.requestId) {
            this.loading = false;
          }
        });
      }, 150);
    },

    change(o) {
      this.stopPending();
      this.$emit("change", o);
    }
  }
};
</script>
